import React from 'react';
import Modal from 'react-modal';
import { Container, Button, Row, Col } from 'react-bootstrap';
import { FM_DOMAIN_NAME, FM_FILENAME_QUALITY, FM_CHECKLIST_SHORTCUT, FM_ACCOUNT_NAME, FM_ACCOUNT_PASSWORD } from "../../config.js"; //CHANGED UPDATE 2023/06/28 #18
import { formatDate, RowColInModal } from '../../Function/Function.js';

Modal.setAppElement("#root");

const customStyles = {
  overlay: {
    zIndex: "1031",
    backgroundColor: "rgba(0, 0, 0, 0.5)"
  },
  content: {
    width: "72%",
    maxWidth: "480px",
    height: "auto",
    maxHeight: "92vh",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    boxSizing: "border-box",
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "0",
    transform: "translate(-50%, -50%)"
  }
};

const ClickEventModal = (props) => {
  const { modalIsOpen, schedulerData, modalParam, linestatus, refStatus, refSetpicture, refKatagae, refSyutuzu, refTbikou, refText, handleClickEventCloseModal, handleSelectedDateUpdateButtonClicked, handleBikouUpdateButtonClicked, handleSyukkaUpdateButtonClicked } = props;
  const { UUID, 製品番号, 立米, 配合, ステータス, セット写真撮影, 打設期限, 型替, 製造用図面の出図, 図面番号, テクノ備考, 備考, 備考フラグ, 出荷日テキスト, 出荷日テキストフラグ, 日付, resourceId, updateDate, updateUserName } = modalParam;
  const formatUpdateDate = new Date(updateDate);

  var options = linestatus.map(
    (item) => (
      <option key={item.status} value={item.status}>
        {item.status}
      </option>
    )
  );
  const parseMixName = 配合.includes("/") ? 配合 : `${配合 || "-"}/-`;

  const pDate = new Date(打設期限);

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={handleClickEventCloseModal}
      // afterOpenModal={afterOpenModal}
      contentLabel="Modal"
      // closeTimeoutMS={100}
      style={customStyles}
    >
      {modalParam && 製品番号 &&
        <Container
          className='container__product'
          style={{
            flex: "1 1 auto",
            minHeight: 0,
            maxHeight: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            padding: "14px 16px 18px",
            boxSizing: "border-box",
            WebkitOverflowScrolling: "touch"
          }}
        >{/* CHANGED UPDATE 2023/07/12 #28 */}
          <Row>
            {/* CHANGED:ADD 2023/07/04 #25 */}
            <div className='fm-link__checklist'>
            <a href={`fmp://${FM_ACCOUNT_NAME}:${FM_ACCOUNT_PASSWORD}@${FM_DOMAIN_NAME}/${FM_FILENAME_QUALITY}?script=${FM_CHECKLIST_SHORTCUT.scriptName}&param=${UUID}`}>
                <i /><span>チェックリストを開く</span></a>
            </div>
          </Row>
          <Row>
            <Col xs={4}>製品番号</Col>
            <Col xs={8}>{製品番号}</Col>
          </Row>
          <Row>
            <Col xs={4}>㎥（打設）</Col>{/* CHANGED:ADD #11 */}
            <Col xs={8}>
              {RowColInModal(立米, true)}
            </Col>
          </Row>
          <Row>
            <Col xs={4}>配合</Col>
            <Col xs={8}>{RowColInModal(parseMixName, false)}</Col>
          </Row>
          <Row>
            <Col xs={4}>打設期限</Col>
            <Col xs={8}>{!isNaN(pDate.getTime()) ? formatDate(pDate , "YYYY/MM/DD"): "-"}</Col>
          </Row>
          <Row>
            <Col xs={4}>ステータス</Col>
            <Col xs={8}>
              <select defaultValue={ステータス} ref={refStatus}>
                {options}
              </select>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>セット写真撮影</Col>
            <Col ref={refSetpicture} xs={8}>{セット写真撮影}</Col>
          </Row>
          <Row>
            <Col xs={4}>型替</Col>
            <Col xs={8}>
              <select defaultValue={型替} ref={refKatagae}>
                <option value={""}>{""}</option>
                <option value={"無"}>{"無"}</option>
                <option value={"有"}>{"有"}</option>
              </select>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>製造用図面の出図</Col>
            <Col xs={8}>
              <select defaultValue={製造用図面の出図} ref={refSyutuzu}>
                <option value={""}>{""}</option>
                <option value={"済"}>{"済"}</option>
              </select>
            </Col>
          </Row>
          <Row>
            <Col xs={4}>図面番号</Col>
            <Col xs={8}>{図面番号}</Col>
          </Row>
          <Row>
            <Col xs={4}>備考</Col>
            <Col xs={8}><input type="text" defaultValue={テクノ備考} ref={refTbikou} /></Col>
          </Row>
          <Row className='btn_area'>
            <div className="mdl_btn mdl_click">
              <div className="mdl_btn_update">
                <Button onClick={() => { handleSelectedDateUpdateButtonClicked(schedulerData, UUID); }}>更新</Button>
              </div>
              <div className="mdl_btn_cancel">
                <Button onClick={handleClickEventCloseModal}>キャンセル</Button>
              </div>
            </div>
            <div className='update_area'>
              <div>{formatDate(formatUpdateDate,'YYYY/MM/DD hh:mm:ss')}</div>
              <div>{updateUserName}</div>
            </div>
          </Row>
        </Container>
      }
      {modalParam && !製品番号 && 備考フラグ &&
        <Container className='text_only'>
          <Row>
            <Col xs={4}>備考</Col>
            <Col xs={8}><input type="text" defaultValue={備考} ref={refText} /></Col>
          </Row>
          <Row className='btn_area'>
            <div className="mdl_btn mdl_click">
              <div className="mdl_btn_update">
                <Button onClick={() => { handleBikouUpdateButtonClicked(schedulerData, UUID, resourceId, 日付); }}>更新</Button>
              </div>
              <div className="mdl_btn_cancel">
                <Button onClick={handleClickEventCloseModal}>キャンセル</Button>
              </div>
            </div>
          </Row>
        </Container>
      }
      {modalParam && !製品番号 && 出荷日テキストフラグ &&
        <Container className='text_only'>
          <Row>
            <Col xs={4}>出荷</Col>
            <Col xs={8}><input type="text" defaultValue={出荷日テキスト} ref={refText} /></Col>
          </Row>
          <Row className='btn_area'>
            <div className="mdl_btn mdl_click">
              <div className="mdl_btn_update">
                <Button onClick={() => { handleSyukkaUpdateButtonClicked(schedulerData, UUID, resourceId, 日付); }}>更新</Button>
              </div>
              <div className="mdl_btn_cancel">
                <Button onClick={handleClickEventCloseModal}>キャンセル</Button>
              </div>
            </div>
          </Row>
        </Container>
      }
    </Modal>
  )
}

export default ClickEventModal; 